import { useContext, useEffect } from 'react';
import './App.css';
import './Style/Style.css';
import './Style/Responsive.css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import Header from './Component/Header';
import { Route, Routes, Outlet, Navigate, useLocation } from 'react-router-dom';
import Login from './Component/Auth/Login';
import ShowToast from './Component/ShowToast';
import { MyContext } from './Context/MyProvider';
import Signup from './Component/Auth/Signup';
import Forgot_password from './Component/Auth/Forgot_password';
import Astrologers_details from './Component/pages/Astrologers_details';
import Dashboard from './Component/pages/Dashboard';
import Wallet from './Component/pages/Wallet';
import Chat_width_astrologer from './Component/pages/Chat_width_astrologer';
import Kundli_Matching from './Component/pages/Kundli_Matching';
import AppointmentList from './Component/pages/AppointmentList';
import Janam_Kundali_details from './Component/pages/Janam_Kundali_details';
import Freekundli from './Component/pages/Freekundli';
import secureLocalStorage from 'react-secure-storage';
import Chat from './Component/pages/Chat';
import Horoscope from './Component/pages/Horoscope';
import Profile from './Component/pages/Profile'; 
import AstrologerAi from './Component/pages/AstrologerAi';
import Pages from './Component/pages/Pages';
import Following from './Component/pages/Following';
import PageNotFound from './Component/PageNotFound';
import RecentPost from './Component/pages/RecentPost';
import Kundali_Matching_details from './Component/pages/Kundali_Matching_details';
import Home from './Component/pages/Home';
import PaymentRes from './Payment-Getway/PaymentRes';
import Cetagory from './Component/pages/Cetagory';
import Soketcall from './Component/Soketcall';
import Footer from './Component/Footer';
import i18n from './Component/Language';
function App() {

  const { istoast, setIsAuth, isauth, setUserLogin } = useContext(MyContext);

  const Location = useLocation();

  const IsShow = Location.pathname.startsWith("/login") || Location.pathname.startsWith("/signup") || Location.pathname.startsWith("/chat");

  useEffect(() => {
    const handleStorageChange = (event) => {
      // if (!isauth) return;
      if (event.key === null || event.key == "@secure.n.Userid" || event.key == "@secure.s.Logindata" || event.key == "@secure.b.isAuthenticated") {
        sessionStorage.clear();
        secureLocalStorage.clear();
        setIsAuth(false);
        setUserLogin(prev => prev + 1);
        window.location.href = "/";
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <div className="App min-h-screen flex flex-col">

      <Header /> 
      <div className="mt-[70px] flex-grow">

        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/auth/login' element={<Login />} />
          <Route path='/auth/signup' element={<Signup />} />
          <Route path='/auth/forgot-password' element={<Forgot_password />} />
          <Route path='/kundli-matching' element={<Kundli_Matching />} />
          <Route path='/horoscope' element={<Horoscope />} />
          <Route path='/freekundli' element={<Freekundli />} />
          <Route path='/kundali-match-detail' element={<Kundali_Matching_details />} />
          <Route path='/janam-kundali-details' element={<Janam_Kundali_details />} />
          <Route path='/astrologers/:id' element={<Astrologers_details />} />
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/recent-post' element={<RecentPost />} />
          <Route path='/chat-width-astrologer' element={<Chat_width_astrologer />} />
          <Route path='/pages/:title' element={<Pages />} />
          <Route path='/cetagory/:title' element={<Cetagory />} />
          <Route path='*' element={<PageNotFound />} />

          <Route element={<ProtectedRoute isauth={isauth} />}>
            <Route path='/wallet' element={<Wallet />} />
            <Route path='/appointment-list' element={<AppointmentList />} />
            <Route path='/chat/:name' element={<Chat />} />
            <Route path='/profile' element={<Profile />} />
            <Route path='/astrologer-ai' element={<AstrologerAi />} />
            <Route path='/following' element={<Following />} />
            <Route path='/payment-response' element={<PaymentRes />} />
          </Route>

        </Routes>
      </div>

      {!IsShow && <Footer />}

      {istoast && <div className="toast_model items-end">
        <ShowToast />
      </div>}

      <Soketcall />

    </div>
  );
}

export default App;


const ProtectedRoute = () => {
  const isauth = secureLocalStorage.getItem("isAuthenticated") || false;
  return isauth ? <Outlet /> : <Navigate to="/" replace />;
};